




























































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyForm) {
  @Prop() type!: string;

  @Prop() codeTypeArr!: any[];

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("oplatformapps/detailweapp", {
      id: this.editId
    });

    if (res && res.Data) {
      this.formData = res.Data;
    }

    this.spinLoading = false;
  }

  handleSubmit() {
    //
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("oplatformapps/editweapp", {
              id: this.editId,
              type: this.type,
              ...fieldValues
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
